import { css } from 'styled-components';
import { disabledLinkEffect } from './disabledLinkEffect';
import { linkHoverEffect } from './linkHoverEffect';
import { rawLinkEffect } from './rawLinkEffect';
export const linkEffect = ({ isDisabled, } = {}) => css `
  ${rawLinkEffect}
  cursor: pointer;

  ${linkHoverEffect}
  ${isDisabled && disabledLinkEffect}
`;
//# sourceMappingURL=linkEffect.js.map